import { NavItem, NavItem1, NavItem2 } from './nav-item/nav-item';


export const navItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'space_dashboard',
    route: '/dashboard',
    PageName: 'Dashboard',
    permissionKey: 'Dashboard',
    permissionKeys: ['Dashboard']
  },
  {
    displayName: 'Funds',
    iconName: 'account_balance',
    route: '/Funds/FundMain',   // was '/ui-components/FundMain'
    PageName: 'Schemes',
    permissionKey: 'Fund',
    permissionKeys: ['Fund']
  },
  {
    displayName: 'Schemes',
    iconName: 'layers',
    route: '/Schemes/badge',   // was '/ui-components/badge' — badge isn't a Schemes route; swap for the actual Schemes landing page you want
    PageName: 'Schemes',
    permissionKey: 'Scheme',
    permissionKeys: ['Scheme']
  },
  {
    displayName: 'Investors',
    iconName: 'groups',
    route: '/Investor/investors',   // was '/ui-components/investors'
    PageName: 'Investors',
    permissionKey: 'Investor',
    permissionKeys: ['Investor']
  },
  {
    displayName: 'Capital Activity',
    iconName: 'trending_up',
    route: '/Capital-calls/capitalcalls',   // was '/ui-components/capitalcalls'
    PageName: 'Schemes',
    permissionKey: 'CapitalCall',
    permissionKeys: ['CapitalCall']
  },
  {
    displayName: 'Distribution',
    iconName: 'call_split',
    route: '/Distribution/DistributionMain',   // was '/ui-components/DistributionMain'
    PageName: 'Schemes',
    permissionKey: 'Distribution',
    permissionKeys: ['Distribution']
  },
  {
    displayName: 'Portfolio Investments',
    iconName: 'finance',
    route: '/Portfolio-investments/PortfolioInvestments',   // was '/ui-components/PortfolioInvestments'
    PageName: 'Portfolio Investments',
    permissionKey: 'PORTFOLIO_INVESTMENTS_VIEW',
    permissionKeys: ['PORTFOLIO_INVESTMENTS_VIEW']
  },
  {
    displayName: 'Doc Management',
    iconName: 'description',
    route: '/Doc-management/Documentvault', 
     activeMatchRoute: '/Doc-management/Documentvault',   // was '/ui-components/Documentvault'
    PageName: 'Doc Management',
    // permissionKey: 'DocTemplate',
    permissionKeys: ['DocTemplate', 'DOCVariables', 'DocUpload', 'DocBulkUpload']
  },
  {
    displayName: 'Configuration',
    iconName: 'admin_panel_settings',
    route: '/Admin-ops/improfile',  
     activeMatchRoute: '/Admin-ops/improfile', // was '/ui-components/Adminops'
    PageName: 'Admin Ops',
    permissionKeys: ['Profile', 'Branding', 'Staff', 'CapitalCallPayment', 'UserManagement','Role','UserAccessLog','AuthenticationPolicy', 'Storage','Integration','NotificationLog','EventCatalog', 'EmailConfiguration','NotificationChannel', 'Configguration','AuditLog','ReferenceData','Subscription']
  }
  // {
  //   displayName: 'Communications',
  //   iconName: 'email',
  //   route: '/communications/EmailConfig',   // was '/ui-components/EmailConfig'
  //   PageName: 'Admin Ops',
  //   permissionKey: 'COMMUNICATIONS_VIEW'
  // },
];

export const navItems1: NavItem1[] = [
  {
    displayName: 'SuperAdmin',
    iconName: 'space_dashboard',
    route: '/dashboard',
    PageName:'Dashboard',
         permissionKey: "string"
  },
  {
    displayName: 'IM Management',
    iconName: 'groups',
    route: '/Super-admin/IMList',   // was '/ui-components/IMList'
    PageName:'IMList',
       permissionKey: "string"
  },
  {
    displayName: 'AI Management',
    iconName: 'robot_2',
    route: '/Super-admin/ai-dashboard',   // was '/ui-components/IMList'
    PageName:'AI Management',
    permissionKey: "string"

  },
   {
    displayName: 'IM Products',
    iconName: 'inventory_2',
    route: '/Super-admin/Products',   // was '/ui-components/IMList'
    PageName:'Products',
    permissionKey: "Products"

  },
  {
    displayName: 'IM Modules',
    iconName: 'view_module',
    route: '/Super-admin/Modules',   // was '/ui-components/IMList'
    PageName:'Modules',
    permissionKey: "Modules"

  },
  {
    displayName: 'Configuration',
    iconName: 'settings',
    route: '/Super-admin/AuditLog',
    PageName:'AuditLog',
    permissionKey: "string"

  }
];

export const navItems2: NavItem2[] = [
  {
    displayName: 'Dashboard',
    iconName: 'home',
    route: '/dashboard',
    PageName: 'Dashboard',
    permissionKey: 'Dashboard'
  },
  {
    displayName: 'Investments',
    iconName: 'payments',
    route: '/Customer/Funds',   // was '/ui-components/Funds'
    PageName: 'Investment',
    permissionKey: 'IPInvestorFunds',
    permissionKeys: ['IPInvestorFunds']
  },
  {
    displayName: 'Cash Ledger',
    iconName: 'swap_horiz',
    route: '/Customer/LedgerView',   // was '/ui-components/LedgerView'
    PageName: 'Trancations',
    permissionKey: 'IPInvestorPayments',
     permissionKeys: ['IPInvestorPayments']
  },
  {
    displayName: 'Documents',
    iconName: 'description',
    route: '/Customer/Documents',   // was '/ui-components/Documents'
    PageName: 'Documents',
    permissionKey: 'IPInvestorFunds',
     permissionKeys: ['IPInvestorFunds']
  },
  {
  displayName: 'Profile',
  iconName: 'person',
  route: '/Investor/AddNewInvestor',
  PageName: 'Profile',
  permissionKey: 'Profile'
}
  // {
  //   displayName: 'Messages',
  //   iconName: 'chat',
  //   route: '/Customer/Message',   // was '/ui-components/Message'
  //   PageName: 'Messages'
  // }
];